import React from 'react';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';

import Heading from '../heading/Heading';
import Picture from '../image/Picture';
import webp from '../../images/eu-versand.webp';
import jpg from '../../images/eu-versand.jpg';

const IMAGE_ALT_TEXT = 'Versandkarton mit EU-Flagge und Einfahrt-verboten-Schildern'
    + ' als Metapher für den bürokratisch verhinderten Versand in andere EU-Länder.';

/**
 * Explains why shipping to other EU countries is currently paused (PPWR).
 * Used in the shipping cost overview, which is shown in the shipping cost
 * dialog and on the shipping FAQ page.
 */
const EuShippingPaused = ({ headingLevel, showImage }) => (
    <React.Fragment>
        <Heading
            level={headingLevel || 4} text={<FormattedMessage
                id='SHIPPING_EU'
                description='Label for the EU shipping cost.'
                defaultMessage='Versand innerhalb der EU (pausiert)'
            />}
        />
        <p>
            <FormattedMessage
                id='SHIPPING_EU_PAUSED_INTRO'
                description='Intro of the paused EU shipping explanation.'
                defaultMessage='Europa, wir müssen reden. 📦'
            />
        </p>
        <p>
            <FormattedMessage
                id='SHIPPING_EU_PAUSED_STATUS'
                description='Statement that shipping within the EU is not possible at the moment.'
                defaultMessage='Wir würden gern in die EU verschicken. Können wir gerade leider nicht. 😵‍💫'
            />
        </p>
        <p>
            <FormattedMessage
                id='SHIPPING_EU_PAUSED_PPWR'
                description='Explanation of the bureaucratic effort caused by the PPWR.'
                defaultMessage='Die PPWR macht aus einem kleinen Paket schnell einen kleinen Bürokratie-Marathon: Registrierung, Meldungen, Bevollmächtigte, Gebühren & Co. – je nach Zielland.'
            />
        </p>
        <p>
            <FormattedMessage
                id='SHIPPING_EU_PAUSED_REASON'
                description='Reason why the EU shipping is paused.'
                defaultMessage='Für einen Familienbetrieb schlicht unverhältnismäßig. Deshalb ist unser EU-Ausland-Versand aktuell pausiert.'
            />
        </p>
        <p>
            <FormattedMessage
                id='SHIPPING_EU_PAUSED_CALL_TO_ACTION'
                description='Call to action to give feedback to the EU.'
                defaultMessage='Du findest das genauso absurd? Dann sag’s der EU! 👇'
            />
        </p>
        <p>
            <FormattedHTMLMessage
                id='SHIPPING_EU_PAUSED_FEEDBACK_LINK'
                description='Link to the EU „Have Your Say“ feedback form.'
                defaultMessage='👉 Bis 10.09.2026 direkt bei „Give Feedback“: <a href="https://ec.europa.eu/info/law/better-regulation/have-your-say/initiatives/15352-Packaging-and-packaging-waste-rules-on-national-registers-of-producers_en" target="_blank" rel="noopener noreferrer">EU „Have Your Say“ – Give Feedback</a>'
            />
        </p>
        <p>
            <FormattedMessage
                id='SHIPPING_EU_PAUSED_MEP'
                description='Hint to also contact the own member of the european parliament.'
                defaultMessage='Und gern auch deiner/deinem EU-Abgeordneten. 💌'
            />
        </p>
        <p>
            <FormattedMessage
                id='SHIPPING_EU_PAUSED_OUTRO'
                description='Closing remark of the paused EU shipping explanation.'
                defaultMessage='Denn freier Warenverkehr sollte nicht heißen: frei von Waren, aber voller Formulare. 😂'
            />
        </p>
        {showImage && <Picture webp={webp} src={jpg} altText={IMAGE_ALT_TEXT} />}
        <p>
            <FormattedHTMLMessage
                id='SHIPPING_LOGOIX'
                description='Text für den logoix.com Versandservice.'
                defaultMessage='Für Kunden in der EU bietet <a href="https://www.logoix.com/" target="_blank" rel="noopener noreferrer">logoix.com</a> eine Lösung. Nähere Informationen findest Du unter <a href="https://www.logoix.com/" target="_blank" rel="noopener noreferrer">logoix.com</a>.'
            />
        </p>
    </React.Fragment>
);

export default EuShippingPaused;



// WEBPACK FOOTER //
// ./src/components/common/EuShippingPaused.js